export const THEME_LOAD_SUCCESS = 'theme/LOAD_SUCCESS';
export const THEME_EDIT_SUCCESS = 'theme/EDIT_SUCCESS';
export const SET_BUSY = 'theme/SET_BUSY';
export const UNSET_BUSY = 'theme/UNSET_BUSY';
